<template>
  <div class="empty-data">
    <div class="empty-icon" v-if="showIcon">
      <img :src="imgSrc" alt="empty" />
    </div>
    <div class="empty-text">{{ text }}</div>
  </div>
</template>

<script>
export default {
  name: 'FDEmptyData',
  props: {
    text: { type: String, default: '暂无内容' },
    showIcon: { type: Boolean, default: true },
  },
  computed: {
    theme() {
      return this.$route?.query?.theme || this.$store?.state?.theme || 'light'
    },
    imgSrc() {
      try {
        return this.theme === 'dark'
          ? require('@/assets/news/empty-black-block.png')
          : require('@/assets/news/empty-black-white.png')
      } catch (e) {
        return ''
      }
    }
  }
}
</script>

<style scoped>
.empty-data {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 40px 0;
}
.empty-icon {
  width: 200px;
  margin-bottom: 16px;
}
.empty-icon img {
  width: 100%;
  object-fit: contain;
}
.empty-text {
  color: #909399;
  font-size: 14px;
}
</style>
